import { useQuery, useQueryClient } from "react-query";
import { defaultStaleTime } from "../withQueryData";
import { useTennisCourtReservationsApi } from "./useTennisCourtReservationsApi";

export const queryKeys = {
    tennisCourtReservations: (propertyId, from, to) =>
        ["tennisCourtReservations", { propertyId, from, to }],
};

/**
 * Hook for tennis court reservations of a property within an optional date range.
 *
 * @param {string|null} propertyId
 * @param {{ from?: string, to?: string }} [range] - ISO dates (yyyy-MM-dd)
 */
export const useTennisCourtReservationsData = (propertyId, range = {}) => {
    const { findAll, createReservation } = useTennisCourtReservationsApi();
    const queryClient = useQueryClient();
    const from = range.from || null;
    const to = range.to || null;

    const queryResults = useQuery({
        queryKey: queryKeys.tennisCourtReservations(propertyId, from, to),
        queryFn: () => findAll(propertyId, { from, to }),
        staleTime: defaultStaleTime,
        enabled: !!propertyId,
    });

    const _createReservation = async (reservation) => {
        const created = await createReservation(propertyId, reservation);
        await queryClient.invalidateQueries('tennisCourtReservations');
        return created;
    };

    return {
        queryResults,
        createReservation: _createReservation,
    };
};
